import { coreInitiativesIdMapSlice } from './update';

export const updateInitiativeReferences = coreInitiativesIdMapSlice.syncActionCreator;
